<template>
   <div class="page">
     <page-header ></page-header>
     
     <div class="banners"></div>

     <div class="c-container">
         <div class="dh-content">
            <h1>纠纷处理</h1>
            <p><span>北京博久网络科技有限公司平台注重保护用户的合法权益，用户至上是我们的第一原则。</span></p>
            <p>1、遇到用户意见、建议、反馈、投诉等，第一时间进行问题的收集和整理；</p>
            <p>2、可以第一时间处理的咨询类问题，客服将在第一时间对用户进行讲解和解释；</p>
            <p>3、遇到用户反馈的产品问题，将问题收集后，反馈到运营中心，通过运营中心与公司其他部门的沟通，拿出解决方案，告知客服，一般类问题客服人员在24小时对用户进行主动答复，重要类问题客服人员在48小时内对用户进行答复；&nbsp;</p>
            <p>4、遇到投诉类问题，客服第一时间收集和反馈，经过运营中心与相关部门的沟通后，给出处理方案（如：补偿、退还、提供其他服务等），告知客服，客服人员在48小时内对用户进行答复、告知和处理；</p>
            <p>5、遇到处理方案用户不满意的纠纷类问题，客服人员在答复告知后，用户不接受处理方案时，我司将安排绿色通道，由客服经理与用户进行直接沟通（电话、邮件、QQ等），进行专项处理，给与玩家的补偿方案将按处理时间的延长，增加对用户的补偿，直到确保用户满意；&nbsp;</p>
            <p>6、用户合法权益受到侵害时，我司会积极协助进行取证和协调解决。&nbsp;</p>
            <p>1、用户权益第一；</p>
            <p>2、耐心对待每一位用户；</p>
            <p>3、凡是查证属实的问题，我司都将按照现行法律规定给予用户必要的补偿。</p>
            <p><span>备注：</span>对于用户注册过程中登记的个人资料情况，本公司同意在未获得用户同意以前，不对外揭露，但以下情况除外：相应的政府机关、司法机关的要求、现行的法律法规的要求；本公司合理怀疑用户有危害国家安全或其他违法情形，本公司将主动配合上级主管部门进行核查</p>
          </div>
      </div>
     <page-footer v-if="$route.meta.hasFooter"></page-footer>
   </div>
</template>
<script>
import Vue from 'vue'

export default {
  components: {
    pageFooter: () => import('@/components/footer'),
    pageHeader: () => import('@/components/layout/page-header')
  },
  data () {
    return {
     
    }
  },
  created () {
  },
  mounted () {
  },
  
  methods: {
    
  }
}
</script>
<style lang="less" scoped>
.main{
  max-width: 512px;
  margin: 0 auto;
  position: relative;
}

.banners{
  height: 130px;
  background: url(../../assets/images/agreement-bg.jpg) no-repeat center;
  background-size: cover;
}

.c-container{
	width: 100%;
}

.dh-content{
	position: relative;
	max-width: 512px;
	top: -40px;
	overflow: auto;
	margin: 0 auto;
	color: #333;
	margin-top: 5px;
	margin-bottom: 5px;
	padding-top: 20px;
	padding-bottom: 25px;
	padding-left: 20px;
	padding-right: 20px;
	background: #fff;
	box-shadow: 0 3px 5px rgba(0,0,0,.3);
}
.ag-content{
	position: relative;
	width: 100%;
	top: 10px;
	overflow: auto;
	margin: 0 auto;
	color: #333;
	margin-top: 5px;
	margin-bottom: 5px;
	padding-top: 20px;
	padding-bottom: 80px;
	padding-left: 20px;
	padding-right: 20px;
	background: #fff;
	box-shadow: 0 3px 5px rgba(0,0,0,.3);	
}
.dh-content h1,.ag-content h1{
	text-align: center;
	font-size: 13px;
	color: #333;
	margin-bottom: 10px;
}
.dh-content p,.ag-content p{
	line-height: 18px;
  font-size: 8px;
}
.dh-content p span,.ag-content p span{
	color: #000;
	font-weight: bold;
}
.dh-content p.title,.ag-content p.title{
	color: #000;
	font-weight: bold;
}
.dh-content p.title-1,.ag-content p.title-1{
	color: #000;
	font-weight: bold;
}


@media (max-width:800px) {
  .dh-content{
    top: 0;
    
  }
}

</style>
